module.exports = __webpack_public_path__ + "img/dz.439802ba.png";